import {
	GET_POSITION_GROUPS,
	ADD_POSITION_GROUP,
	GET_GROUP_TYPES,
	DELETE_POSITION_GROUP,
	UPDATE_POSITION_GROUP
} from '../../Actions/Admin/ManagePositionGroupAction';

const initialState = {
	positionGroups: [],
	groupTypes: []
};
export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_POSITION_GROUPS:
			return {
				...state,
				positionGroups: action.payload
			};

		case ADD_POSITION_GROUP:
			return {
				...state,
				positionGroups: action.payload
			};
		case DELETE_POSITION_GROUP:
			return {
				...state,
				positionGroups: action.payload
			};
		case GET_GROUP_TYPES:
			return {
				...state,
				groupTypes: action.payload
			};
		case UPDATE_POSITION_GROUP:
			return {
				...state,
				positionGroups: action.payload
			};

		default:
			return state;
	}
};
